import { useRef } from "react";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { Container, Anchor } from "./PopOut.styles";
import { Menu } from "./Menu";
import { Calendar } from "./Calendar";
import { useApplication } from "src/pages/ApplicationDetailPage/ApplicationContext";
import { zeroDate } from "src/constants";
import { createIsoDate } from "src/utils";

export type DateField =
  | "target_delivery_date"
  | "target_funding_date"
  | "application_date"
  | "last_updated_at";

interface PopOutProps {
  isVisible: boolean;
  closeHandler: () => void;
  showCalendar: boolean;
  setShowCalendar: (show: boolean) => void;
  field: DateField;
}

export default ({
  isVisible,
  closeHandler,
  showCalendar,
  setShowCalendar,
  field,
}: PopOutProps) => {
  const { application, updateApplicationDetails } = useApplication();
  const popOutRef = useRef<HTMLDivElement>(null);
  const newDate = new Date(application[field] ?? "");
  const selectedDate = new Date(
    newDate.getTime() + newDate.getTimezoneOffset() * 60000,
  );

  useClickOutsideModalListener(popOutRef, () => {
    closeHandler();
  });

  const handleDateSelect = async (selectedDate: Date | undefined) => {
    if (!selectedDate) return;
    const utcDate = createIsoDate(
      selectedDate.getUTCFullYear(),
      selectedDate.getUTCMonth() + 1,
      selectedDate.getUTCDate(),
    );

    await updateApplicationDetails({ [field]: utcDate });
    closeHandler();
  };

  const handleRemoveDate = async () => {
    await updateApplicationDetails({ [field]: zeroDate });
    closeHandler();
  };

  return (
    <Anchor ref={popOutRef}>
      <Container isVisible={isVisible} showCalendar={showCalendar}>
        {showCalendar ? (
          <Calendar
            selected={selectedDate}
            onSelect={(date) => void handleDateSelect(date)}
          />
        ) : (
          <Menu
            showCalendar={() => setShowCalendar(true)}
            onSelect={() => void handleRemoveDate()}
          />
        )}
      </Container>
    </Anchor>
  );
};
